function ProgressBar({progress}) {
    return (
        <div className="progress"
             role="progressbar">
            <div className="progress-bar" style={{width: `${progress}%`}}/>
        </div>
    );
}
export default ProgressBar;